<template>
	<div>
        <div class="row">
            <el-card class="pt-1 pb-4" shadow="always" :body-style="{ padding: '10px'}" style="width:100%;">
                <div class="row">
                    <div class="col-md-6">
                        <el-button size="mini" @click="$router.push('/performance-report/rasio-keuangan')"><i class="fa fa-angle-left"></i></el-button>
                    </div>
                    <div class="col-md-6 text-right">
                        <el-button size="mini" @click="toggleFullscreen"><i :class="[toggleIcon ? 'fa-compress' : 'fa-arrows-alt', 'fa']"></i></el-button>
                        <el-button size="mini" @click="$router.push('/performance-report/realisasi-capex')"><i class="fa fa-angle-right"></i></el-button>
                    </div>
                </div>

                <h4 class="text-center">REALISASI ABO YTD {{ this.options.months.find(d=> d.value==this.month).name.toUpperCase() }} {{ this.year }}</h4>

                <el-form  class="mt-2" label-position="top" label-width="100px">
                    <div class="row">
                        <div class="col-md-2">	
                            <el-form-item label="Bulan:">
                                <el-select v-model="month" clearable filterable placeholder="Select Month" size="medium" style="width:100%;">
                                    <el-option v-for="item3 in options.months" :key="item3.value" :label="item3.name" :value="item3.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-2">	
                            <el-form-item label="Tahun:" style="min-width:85px;">
                                <el-select v-model="year" clearable filterable placeholder="Select Year" size="medium" style="width:100%;">
                                    <el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-2">	
                            <el-form-item label=" ">
                                <el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply</el-button>
                            </el-form-item>
                        </div>
                        <div class="col-md-6 text-right" v-if="lastUpdate != ''">
                            <el-form-item label=" ">
                                <div v-html="lastUpdate"></div>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>

                <div class="row">
                    <div :class="(String(this.description || '').trim().length > minLengthDescription ? 'col-md-9 pr-4' : 'col-md-12' ) + ' '">
                        <div class="row mt-1">
                            <div class="col-md-12 pr-0" style="overflow-x: auto;">
                                
                                <table class="app-table">
                                    <tr>
                                        <th>No</th>
                                        <th style="min-width: 200px;">Komponen Utama</th>
                                        <th>Real ABO {{this.year - 1}}</th>
                                        <th style="min-width: 100px;">RKAP ABO {{this.year}}</th>
                                        <th style="min-width: 130px;">Prop RKAP {{this.year}}</th>
                                        <th style="min-width: 150px;">Real ABO YTD {{this.options.months.find(d=> d.value==this.month).name}} {{this.year}}</th>
                                        <th style="min-width: 150px;">% Real ABO YTD {{this.options.months.find(d=> d.value==this.month).name}} {{this.year}} vs Real {{this.year-1}}</th>
                                        <th style="min-width: 150px;">% Real ABO YTD {{this.options.months.find(d=> d.value==this.month).name}} {{this.year}} vs RKAP {{this.year}}</th>
                                        <th style="min-width: 150px;">% Real ABO YTD {{this.options.months.find(d=> d.value==this.month).name}} {{this.year}} vs Prop RKAP {{this.year}}</th>
                                    </tr>
                                    <tr></tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td class="text-center">A</td>
                                        <td class="text-center">B</td>
                                        <td class="text-center">C</td>
                                        <td class="text-center">D</td>
                                        <td class="text-center">E=D:A</td>
                                        <td class="text-center">F=D:B</td>
                                        <td class="text-center">G=D:C</td>
                                    </tr>
                                    <tr v-for="(item, idx) in this.reportData.data.group_a" :key="item.ComponentCode">
                                        <td class="text-center">{{ ++idx }}</td>
                                        <td class="text-left">{{ item.ComponentName }}</td>
                                        <td class="text-right">{{ formatNum(item.RealizationTotalBefore) }}</td>
                                        <td class="text-right">{{ formatNum(item.RKAPTotal) }}</td>
                                        <td class="text-right">{{ formatNum(item.RKAPProp) }}</td>
                                        <td class="text-right">{{ formatNum(item.Realization) }}</td>
                                        <td class="text-right">{{ formatNum(item.PercentageRealizaion) }}%</td>
                                        <td class="text-right">{{ formatNum(item.PercentageRKAP) }}%</td>
                                        <td class="text-right">{{ formatNum(item.PercentageProp) }}%</td>
                                    </tr>
                                    <tr v-for="(item) in this.reportData.data.group_a_total" :key="item.ComponentCode" class="text-bold">
                                        <td class="text-center"></td>
                                        <td class="text-left">Sub Total I</td>
                                        <td class="text-right">{{ formatNum(item.RealizationTotalBefore) }}</td>
                                        <td class="text-right">{{ formatNum(item.RKAPTotal) }}</td>
                                        <td class="text-right">{{ formatNum(item.RKAPProp) }}</td>
                                        <td class="text-right">{{ formatNum(item.Realization) }}</td>
                                        <td class="text-right">{{ formatNum(item.PercentageRealizaion) }}%</td>
                                        <td class="text-right">{{ formatNum(item.PercentageRKAP) }}%</td>
                                        <td class="text-right">{{ formatNum(item.PercentageProp) }}%</td>
                                    </tr>

                                    <tr v-for="(item, idx) in this.reportData.data.group_b" :key="item.ComponentCode">
                                        <td class="text-center">{{ idx + reportData.data.group_a.length + 1}}</td>
                                        <td class="text-left">{{ item.ComponentName }}</td>
                                        <td class="text-right">{{ formatNum(item.RealizationTotalBefore) }}</td>
                                        <td class="text-right">{{ formatNum(item.RKAPTotal) }}</td>
                                        <td class="text-right">{{ formatNum(item.RKAPProp) }}</td>
                                        <td class="text-right">{{ formatNum(item.Realization) }}</td>
                                        <td class="text-right">{{ formatNum(item.PercentageRealizaion) }}%</td>
                                        <td class="text-right">{{ formatNum(item.PercentageRKAP) }}%</td>
                                        <td class="text-right">{{ formatNum(item.PercentageProp) }}%</td>
                                    </tr>
                                    <tr v-for="(item) in this.reportData.data.group_b_total" :key="item.ComponentCode" class="text-bold">
                                        <td class="text-center"></td>
                                        <td class="text-left">Sub Total II</td>
                                        <td class="text-right">{{ formatNum(item.RealizationTotalBefore) }}</td>
                                        <td class="text-right">{{ formatNum(item.RKAPTotal) }}</td>
                                        <td class="text-right">{{ formatNum(item.RKAPProp) }}</td>
                                        <td class="text-right">{{ formatNum(item.Realization) }}</td>
                                        <td class="text-right">{{ formatNum(item.PercentageRealizaion) }}%</td>
                                        <td class="text-right">{{ formatNum(item.PercentageRKAP) }}%</td>
                                        <td class="text-right">{{ formatNum(item.PercentageProp) }}%</td>
                                    </tr>

                                    <tr v-for="(item, idx) in this.reportData.data.group_c" :key="item.ComponentCode">
                                        <td class="text-center">{{ idx + (reportData.data.group_a.length + reportData.data.group_b.length + 1)}}</td>
                                        <td class="text-left">{{ item.ComponentName }}</td>
                                        <td class="text-right">{{ formatNum(item.RealizationTotalBefore) }}</td>
                                        <td class="text-right">{{ formatNum(item.RKAPTotal) }}</td>
                                        <td class="text-right">{{ formatNum(item.RKAPProp) }}</td>
                                        <td class="text-right">{{ formatNum(item.Realization) }}</td>
                                        <td class="text-right">{{ formatNum(item.PercentageRealizaion) }}%</td>
                                        <td class="text-right">{{ formatNum(item.PercentageRKAP) }}%</td>
                                        <td class="text-right">{{ formatNum(item.PercentageProp) }}%</td>
                                    </tr>
                                    <tr v-for="(item) in this.reportData.data.group_c_total" :key="item.ComponentCode" class="text-bold">
                                        <td class="text-center"></td>
                                        <td class="text-left">Sub Total III</td>
                                        <td class="text-right">{{ formatNum(item.RealizationTotalBefore) }}</td>
                                        <td class="text-right">{{ formatNum(item.RKAPTotal) }}</td>
                                        <td class="text-right">{{ formatNum(item.RKAPProp) }}</td>
                                        <td class="text-right">{{ formatNum(item.Realization) }}</td>
                                        <td class="text-right">{{ formatNum(item.PercentageRealizaion) }}%</td>
                                        <td class="text-right">{{ formatNum(item.PercentageRKAP) }}%</td>
                                        <td class="text-right">{{ formatNum(item.PercentageProp) }}%</td>
                                    </tr>
                                    <tr v-for="(item) in this.reportData.data.group_grand_total" :key="item.ComponentCode" class="text-bold">
                                        <td class="text-center"></td>
                                        <td class="text-left">Grand Total</td>
                                        <td class="text-right">{{ formatNum(item.RealizationTotalBefore) }}</td>
                                        <td class="text-right">{{ formatNum(item.RKAPTotal) }}</td>
                                        <td class="text-right">{{ formatNum(item.RKAPProp) }}</td>
                                        <td class="text-right">{{ formatNum(item.Realization) }}</td>
                                        <td class="text-right">{{ formatNum(item.PercentageRealizaion) }}%</td>
                                        <td class="text-right">{{ formatNum(item.PercentageRKAP) }}%</td>
                                        <td class="text-right">{{ formatNum(item.PercentageProp) }}%</td>
                                    </tr>

                                </table>
                                <Loader v-show="loading.table"/>
                                <!--
                                <el-table
                                    :data="tableData"
                                    stripe
                                    style="width: 100%; font-size:12px;"
                                    :header-cell-style="{paddingTop: '8px', paddingBottom: '2px', background: '#F5F7FA'}"
                                    :header-row-style="{padding:'0px'}"
                                    :cell-style="{padding: '8px 0px', borderBottom: '1px solid #EBEEF5', borderRight: '0px solid #EBEEF5'}"   >

                                    <el-table-column
                                        fixed
                                        prop="kolom1"
                                        label="No"
                                        width="50"
                                        align="center"
                                        header-align="center">
                                    </el-table-column>

                                    <el-table-column
                                        fixed
                                        prop="kolom2"
                                        label="Komponen Utama"
                                        header-align="center">
                                    </el-table-column>

                                    <el-table-column
                                        fixed
                                        prop="kolom3"
                                        label="Real ABO 2022 Unaudited"
                                        align="right"
                                        header-align="center">
                                    </el-table-column>

                                    <el-table-column
                                        fixed
                                        prop="kolom4"
                                        label="RKAP ABO 2023"
                                        align="right"
                                        header-align="center">
                                    </el-table-column>

                                    <el-table-column
                                        fixed
                                        prop="kolom5"
                                        label="Prop RKAP 2023"
                                        align="right"
                                        header-align="center">
                                    </el-table-column>

                                    <el-table-column
                                        fixed
                                        prop="kolom6"
                                        label="Real ABO YTD Mei 2023"
                                        align="right"
                                        header-align="center">
                                    </el-table-column>

                                    <el-table-column
                                        fixed
                                        prop="kolom7"
                                        label="% Real ABO YTD Mei 2023 vs Real 2022 Unaudited"
                                        align="right"
                                        header-align="center">
                                    </el-table-column>

                                    <el-table-column
                                        fixed
                                        prop="kolom8"
                                        label="% Real ABO YTD Mei 2023 vs RKAP 2023"
                                        align="right"
                                        header-align="center">
                                    </el-table-column>

                                    <el-table-column
                                        fixed
                                        prop="kolom9"
                                        label="% Real ABO YTD Mei 2023 vs Prop RKAP 2023"
                                        align="right"
                                        header-align="center">
                                    </el-table-column>

                                </el-table>
                            -->
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col-md-12 pr-0" style="overflow-x: auto;">
                                <table class="app-table">
                                    <tr>
                                        <th>No</th>
                                        <th style="min-width: 200px;">Komponen Utama</th>
                                        <th>Real ABO {{this.year - 1}}</th>
                                        <th style="min-width: 100px;">RKAP ABO {{this.year}}</th>
                                        <th style="min-width: 130px;">Prop RKAP {{this.year}}</th>
                                        <th style="min-width: 150px;">Real ABO YTD {{this.options.months.find(d=> d.value==this.month).name}} {{this.year}}</th>
                                        <th style="min-width: 150px;">% Real ABO YTD {{this.options.months.find(d=> d.value==this.month).name}} {{this.year}} vs Real {{this.year-1}}</th>
                                        <th style="min-width: 150px;">% Real ABO YTD {{this.options.months.find(d=> d.value==this.month).name}} {{this.year}} vs RKAP {{this.year}}</th>
                                        <th style="min-width: 150px;">% Real ABO YTD {{this.options.months.find(d=> d.value==this.month).name}} {{this.year}} vs Prop RKAP {{this.year}}</th>
                                    </tr>
                                    <tr></tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td class="text-center">A</td>
                                        <td class="text-center">B</td>
                                        <td class="text-center">C</td>
                                        <td class="text-center">D</td>
                                        <td class="text-center">E=D:A</td>
                                        <td class="text-center">F=D:B</td>
                                        <td class="text-center">G=D:C</td>
                                    </tr>
                                    <tr v-for="(item, idx) in this.reportData.data.group_d" :key="item.ComponentCode">
                                        <td class="text-center">{{ ++idx }}</td>
                                        <td class="text-left">{{ item.ComponentName }}</td>
                                        <td class="text-right">{{ formatNum(item.RealizationTotalBefore) }}</td>
                                        <td class="text-right">{{ formatNum(item.RKAPTotal) }}</td>
                                        <td class="text-right">{{ formatNum(item.RKAPProp) }}</td>
                                        <td class="text-right">{{ formatNum(item.Realization) }}</td>
                                        <td class="text-right">{{ formatNum(item.PercentageRealizaion) }}%</td>
                                        <td class="text-right">{{ formatNum(item.PercentageRKAP) }}%</td>
                                        <td class="text-right">{{ formatNum(item.PercentageProp) }}%</td>
                                    </tr>
                                    <tr v-for="(item) in this.reportData.data.group_d_total" :key="item.ComponentCode" class="text-bold">
                                        <td class="text-center"></td>
                                        <td class="text-left">Grand Total</td>
                                        <td class="text-right">{{ formatNum(item.RealizationTotalBefore) }}</td>
                                        <td class="text-right">{{ formatNum(item.RKAPTotal) }}</td>
                                        <td class="text-right">{{ formatNum(item.RKAPProp) }}</td>
                                        <td class="text-right">{{ formatNum(item.Realization) }}</td>
                                        <td class="text-right">{{ formatNum(item.PercentageRealizaion) }}%</td>
                                        <td class="text-right">{{ formatNum(item.PercentageRKAP) }}%</td>
                                        <td class="text-right">{{ formatNum(item.PercentageProp) }}%</td>
                                    </tr>
                                </table>
                                <Loader v-show="loading.table"/>
                                <!--
                                <el-table
                                    :data="tableData2"
                                    stripe
                                    style="width: 100%; font-size:12px;"
                                    :header-cell-style="{paddingTop: '8px', paddingBottom: '2px', background: '#F5F7FA'}"
                                    :header-row-style="{padding:'0px'}"
                                    :cell-style="{padding: '8px 0px', borderBottom: '1px solid #EBEEF5', borderRight: '0px solid #EBEEF5'}"   >

                                    <el-table-column
                                        fixed
                                        prop="kolom1"
                                        label="No"
                                        width="50"
                                        align="center"
                                        header-align="center">
                                    </el-table-column>

                                    <el-table-column
                                        fixed
                                        prop="kolom2"
                                        label="Komponen Utama"
                                        header-align="center">
                                    </el-table-column>

                                    <el-table-column
                                        fixed
                                        prop="kolom3"
                                        label="Real ABO 2022 Unaudited"
                                        align="right"
                                        header-align="center">
                                    </el-table-column>

                                    <el-table-column
                                        fixed
                                        prop="kolom4"
                                        label="RKAP ABO 2023"
                                        align="right"
                                        header-align="center">
                                    </el-table-column>

                                    <el-table-column
                                        fixed
                                        prop="kolom5"
                                        label="Prop RKAP 2023"
                                        align="right"
                                        header-align="center">
                                    </el-table-column>

                                    <el-table-column
                                        fixed
                                        prop="kolom6"
                                        label="Real ABO YTD Mei 2023"
                                        align="right"
                                        header-align="center">
                                    </el-table-column>

                                    <el-table-column
                                        fixed
                                        prop="kolom7"
                                        label="% Real ABO YTD Mei 2023 vs Real 2022 Unaudited"
                                        align="right"
                                        header-align="center">
                                    </el-table-column>

                                    <el-table-column
                                        fixed
                                        prop="kolom8"
                                        label="% Real ABO YTD Mei 2023 vs RKAP 2023"
                                        align="right"
                                        header-align="center">
                                    </el-table-column>

                                    <el-table-column
                                        fixed
                                        prop="kolom9"
                                        label="% Real ABO YTD Mei 2023 vs Prop RKAP 2023"
                                        align="right"
                                        header-align="center">
                                    </el-table-column>

                                </el-table>
                            -->
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3 p-0" style="border:1px solid #2F5597;" v-if="String(this.description || '').trim().length > minLengthDescription">
                        <div class="text-center" style="background:#2F5597;">
                            <h6 style="color:#ffffff;">HIGHLIGHT</h6>
                        </div>
                        <div class="p-3">
                            <div v-html="description"></div>
                            <!--
                            <div style="color:#1D7BBB;"><b>Realisasi Beban Pokok Penjualan</b></div>
                            <p style="text-align:justify;">Realisasi beban pokok penjualan dan beban langsung lainnya 112% melebihi target RKAP Ytd Mei 2023, sejalan dengan peningkatan penjualan 110% dan pergantian spare part dispenser dan maintenance SPBU Rp. 6,82 M, Sarfas IT/internet Rp. 4,45 M.</p>
                            <div style="color:#1D7BBB;"><b>Laba Bruto</b></div>
                            <p style="text-align:justify;">Realisasi Laba bruto under 29% dari target RKAP Ytd Mei 2023 karena dampak dari penurunan Margin SPBU KSO. Besaran dampak penurunan Rp. 41,73 Miliar (Jan=Rp. 8,77 M + Feb=7,83 M + Mar=8,74 M + Apr=7,79 M + Mei 8,6 M).</p>
                            <div style="color:#1D7BBB;"><b>Pajak Penghasilan</b></div>
                            <p style="text-align:justify;">Realisasi Pajak Penghasilan 197% melebihi RKAP 2023 karna realisasi Pajak Mei merujuk dari perhitungan PPh 25 tahun 2022, sedangkan di RKAP memperhitungkan Pph 25 di tahun 2021.</p>
                        -->
                            <Loader v-if="loading.description"/>
                        </div>
                    </div>
                </div>
            </el-card>

        </div>
        
    </div>
</template>

<script>
import KinerjaKeuangan from '@/components/page/KinerjaKeuangan.js'
import {Rainbow, FuelColor, Config,Penanggalan, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'

export default
{
	extends: KinerjaKeuangan,
	components: { 
        Loader,
		//ReportParamSelect,
	},

	data() {
		return {
            columnWidth : 120,
            num: 0,
            month: ""+(Penanggalan().bulan-1),
            year: ""+Penanggalan().tahun,
            description: '',

            loading: {
                table: false,
                description: false,
            },

            reportData: {
                data: {
                    group_a: [],
                    group_b: [],
                    group_c: [],
                    group_d: [],
                    group_a_total: [],
                    group_b_total: [],
                    group_c_total: [],
                    group_d_total: [],
                    group_grand_total: [],
                },
            },

            tableData: [
                {
                    kolom1: '1',
                    kolom2: 'Man Power Related',
                    kolom3: '45,532.00',
                    kolom4: '49,547.00',
                    kolom5: '20,645.00',
                    kolom6: '10,639.00',
                    kolom7: '23.37%',
                    kolom8: '21.47%',
                    kolom9: '51.53%',
                }, 
                {
                    kolom1: '2',
                    kolom2: 'Services',
                    kolom3: '0',
                    kolom4: '0',
                    kolom5: '0',
                    kolom6: '0',
                    kolom7: '0%',
                    kolom8: '0%',
                    kolom9: '0%',
                }, 
                {
                    kolom1: '3',
                    kolom2: 'Material Consumed',
                    kolom3: '0',
                    kolom4: '0',
                    kolom5: '0',
                    kolom6: '0',
                    kolom7: '0%',
                    kolom8: '0%',
                    kolom9: '0%',
                }, 
                {
                    kolom1: '4',
                    kolom2: 'Maintenance',
                    kolom3: '0',
                    kolom4: '0',
                    kolom5: '0',
                    kolom6: '0',
                    kolom7: '0%',
                    kolom8: '0%',
                    kolom9: '0%',
                }, 
                {
                    kolom1: '5',
                    kolom2: 'Promotion & Corp Image',
                    kolom3: '0',
                    kolom4: '0',
                    kolom5: '0',
                    kolom6: '0',
                    kolom7: '0%',
                    kolom8: '0%',
                    kolom9: '0%',
                }, 
                {
                    kolom1: '',
                    kolom2: 'Sub Total 1',
                    kolom3: '0',
                    kolom4: '0',
                    kolom5: '0',
                    kolom6: '0',
                    kolom7: '0%',
                    kolom8: '0%',
                    kolom9: '0%',
                }, 
                {
                    kolom1: '6',
                    kolom2: 'Payroll & Employee Benefit',
                    kolom3: '0',
                    kolom4: '0',
                    kolom5: '0',
                    kolom6: '0',
                    kolom7: '0%',
                    kolom8: '0%',
                    kolom9: '0%',
                }, 
                {
                    kolom1: '7',
                    kolom2: 'Insurance',
                    kolom3: '0',
                    kolom4: '0',
                    kolom5: '0',
                    kolom6: '0',
                    kolom7: '0%',
                    kolom8: '0%',
                    kolom9: '0%',
                }, 
                {
                    kolom1: '8',
                    kolom2: 'Fuel & Product Consumed',
                    kolom3: '0',
                    kolom4: '0',
                    kolom5: '0',
                    kolom6: '0',
                    kolom7: '0%',
                    kolom8: '0%',
                    kolom9: '0%',
                }, 
                {
                    kolom1: '9',
                    kolom2: 'Financial Expense',
                    kolom3: '0',
                    kolom4: '0',
                    kolom5: '0',
                    kolom6: '0',
                    kolom7: '0%',
                    kolom8: '0%',
                    kolom9: '0%',
                }, 
                {
                    kolom1: '',
                    kolom2: 'Sub Total II',
                    kolom3: '0',
                    kolom4: '0',
                    kolom5: '0',
                    kolom6: '0',
                    kolom7: '0%',
                    kolom8: '0%',
                    kolom9: '0%',
                }, 
                {
                    kolom1: '10',
                    kolom2: 'Depreciation',
                    kolom3: '0',
                    kolom4: '0',
                    kolom5: '0',
                    kolom6: '0',
                    kolom7: '0%',
                    kolom8: '0%',
                    kolom9: '0%',
                }, 
                {
                    kolom1: '11',
                    kolom2: 'PPh Final',
                    kolom3: '0',
                    kolom4: '0',
                    kolom5: '0',
                    kolom6: '0',
                    kolom7: '0%',
                    kolom8: '0%',
                    kolom9: '0%',
                }, 
                {
                    kolom1: '',
                    kolom2: 'Sub Total III',
                    kolom3: '0',
                    kolom4: '0',
                    kolom5: '0',
                    kolom6: '0',
                    kolom7: '0%',
                    kolom8: '0%',
                    kolom9: '0%',
                }, 
                {
                    kolom1: '',
                    kolom2: 'Grand Total',
                    kolom3: '0',
                    kolom4: '0',
                    kolom5: '0',
                    kolom6: '0',
                    kolom7: '0%',
                    kolom8: '0%',
                    kolom9: '0%',
                }, 
            ],

            tableData2: [
                {
                    kolom1: '1',
                    kolom2: 'Direct Cost',
                    kolom3: '538,097',
                    kolom4: '598,676',
                    kolom5: '253,272',
                    kolom6: '225,662',
                    kolom7: '41,94%',
                    kolom8: '37,69%',
                    kolom9: '89,10%',
                }, 
                {
                    kolom1: '2',
                    kolom2: 'Overhead Cost',
                    kolom3: '0',
                    kolom4: '0',
                    kolom5: '0',
                    kolom6: '0',
                    kolom7: '0%',
                    kolom8: '0%',
                    kolom9: '0%',
                }, 
                {
                    kolom1: '',
                    kolom2: 'Grand Total',
                    kolom3: '0',
                    kolom4: '0',
                    kolom5: '0',
                    kolom6: '0',
                    kolom7: '0%',
                    kolom8: '0%',
                    kolom9: '0%',
                }, 
            ],
        }
    },
    watch: {

	}, 
    mounted() {
        this.$emit('childrenRoute');
        this.setDefaultPeriod()
        this.resumePilihan()
        this.getDescription() 
    },
    methods: {
        resumePilihan() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/financial-performance/abo?'
            
            this.urlRequestParams+='&year='+this.year
            this.urlRequestParams+='&month='+this.month
            this.urlRequestParams+='&category='+this.category

			this.loading.table = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.reportData = response.data;
                this.lastUpdate = this.reportData.data.last_update
                //console.log('data: ' + JSON.stringify(this.reportData))
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.table = false;
			})     

        },

        getDescription() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/financial-performance/abo-description?'
            
            this.urlRequestParams+='year='+this.year
            this.urlRequestParams+='&month='+this.month

			this.loading.description = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.description = response.data.data.description;
                //console.log('data: ' + JSON.stringify(this.reportData))
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.description = false;
			})     

        },

        applyFilter() {
            this.resumePilihan()
            this.getDescription() 
        },
    },
}
</script>


<style scoped>
.app-table {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
  border-radius:4px;
  width: 100% !important;
  overflow-x: auto; 
}

.app-table td, .app-table th {
  border: 2px solid #fff/*#ddd*/;
  padding: 4px 10px;
}

.app-table tr:nth-child(even){background-color: #e0f3ff/*#D9E1F2*//*#f2f2f2*/;}

.app-table tr:hover {background-color: rgba(66, 161, 255, 0.26) /*#ddd*/;}

.app-table th {
  padding-top: 6px;
  padding-bottom: 6px;
  text-align: center;
  background-color: #409EFF/*#0070C0*/;
  color: white;
}

.sub-header-cell {
    background-color: rgba(66, 161, 255, 0.46) /* #8EA9DB*/;
    font-weight:bold;
    color:#000;
}

.red-border {
    border-left:3px solid #F56C6C !important;
    border-right:3px solid #F56C6C !important;
}

.yellow-border {
    border-left:3px solid #E6A23C !important;
    border-right:3px solid #E6A23C !important;
}

.top-red-border {
    border-top:3px solid #F56C6C !important;
}
.bottom-red-border {
    border-bottom:3px solid #F56C6C !important;
}

.top-yellow-border {
    border-top:3px solid #E6A23C !important;
}

.bottom-yellow-border {
    border-bottom:3px solid #E6A23C !important;
}

.text-chart-title {
    color:#007bff;
    font-weight:bold;
    font-size:18px;
}

.text-bold {
    font-weight:bold;
    color:#252f40;
    font-size:16px;
}

</style>